module.exports = __webpack_public_path__ + "img/volume-high.ffb83524.svg";